// Starter hero section — Flip bento grid animation
// Extracted from original gsap.js (lines 67-116)
// (function () {
//   'use strict';

//   var flipCtx;

//   function createStarterTween() {
//     var starterElement = document.querySelector('#starter');
//     if (!starterElement) return;

//     var starterItems = starterElement.querySelectorAll('.starter__item');

//     if (flipCtx) flipCtx.revert();
//     starterElement.classList.remove('starter--final');

//     var videos = starterElement.querySelectorAll('.starter__item:not(:nth-child(3)) video');
//     var videosAll = starterElement.querySelectorAll('.starter__item video');
//     gsap.set(videos, { scale: 1.5 });

//     flipCtx = gsap.context(function () {
//       starterElement.classList.add('starter--final');
//       var flipState = Flip.getState(starterItems);
//       starterElement.classList.remove('starter--final');

//       var flip = Flip.to(flipState, {
//         simple: true,
//         ease: 'expoScale(1, 5)',
//         label: 'starter_flip',
//       });

//       var tl = gsap.timeline({
//         scrollTrigger: {
//           trigger: starterElement,
//           start: 'center center',
//           end: '+=500%',
//           scrub: true,
//           pin: starterElement.parentNode,
//         },
//       });

//       tl.addLabel('starter_flip', 0);
//       tl.add(flip, 0);

//       tl.to(videos, { scale: 1, ease: 'expoScale(1, 5)' }, 0);

//       videosAll.forEach(function (video, index) {
//         var groupIndex = Math.floor(index / 2);
//         var isSecondInGroup = index % 2 === 1;
//         var startPosition = isSecondInGroup
//           ? 'starter+=' + groupIndex * 25 + '%'
//           : 'starter+=' + groupIndex * 50 + '%';

//         tl.to(video, { autoAlpha: 0, duration: 0.5 }, startPosition);
//       });
//     });
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     if (typeof gsap !== 'undefined' && typeof Flip !== 'undefined') {
//       gsap.registerPlugin(Flip);
//       createStarterTween();
//       window.addEventListener('resize', createStarterTween);
//     }
//   });
// })();
